module.exports = __webpack_public_path__ + "assets/img/picture3.192b5943.png";